import { Injectable } from '@angular/core';

import { ObjectStoragePage } from 'src/app/pages/object-storage/object-storage.page';

import { ConfirmDialogService } from 'src/app/shared/ui/confirm-dialog/confirm-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class ObjectStoreCanDeactivateGuard {

  constructor(private confirmDialog: ConfirmDialogService) {}

  async canDeactivate(component: ObjectStoragePage): Promise<boolean> {
    if (component.uploadingObject) {
      return this.confirmDialog.confirm({
        header: 'Confirm',
        message: 'You have ongoing uploads. Are you sure you want to leave?',
        confirmText: 'Leave',
      });
    }
    return true;
  }
}
